/**
 * Auto select nearest size when unavailable. Retain size when manually selected by user.
  */
(function() {
  'use strict';

  let userSelectedSize = false;

  document.addEventListener('click', function(event) {
    const variantPicker = event.target.closest('variant-picker');
    if (!variantPicker) return;

    const fieldsets = variantPicker.querySelectorAll('fieldset');
    if (fieldsets.length < 2) return;

    const sizeFieldset = fieldsets[1];
    const clickedInput = event.target.closest('input[data-option-name]')
                      || event.target.closest('label')?.querySelector('input[data-option-name]');

    if (clickedInput && sizeFieldset.contains(clickedInput)) {
      userSelectedSize = true;
    }
  });

  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('variant-picker').forEach(function(variantPicker) {
      var variantScript = variantPicker.querySelector('script[data-variant]');
      if (!variantScript) return;

      try {
        var variant = JSON.parse(variantScript.textContent);
        if (!variant || variant.available) return;
      } catch(e) { return; }

      var formId = variantPicker.getAttribute('form-id');
      if (formId) {
        setTimeout(function() { doAutoSelect(formId); }, 100);
      }
    });
  });

  document.addEventListener('dialog:after-show', function(event) {
    if (!event.target.matches('quick-buy-modal')) return;

    userSelectedSize = false;

    event.target.querySelectorAll('variant-picker').forEach(function(variantPicker) {
      var variantScript = variantPicker.querySelector('script[data-variant]');
      if (!variantScript) return;

      try {
        var variant = JSON.parse(variantScript.textContent);
        if (!variant || variant.available) return;
      } catch(e) { return; }

      var formId = variantPicker.getAttribute('form-id');
      if (formId) {
        setTimeout(function() { doAutoSelect(formId); }, 100);
      }
    });
  }, true);

  document.addEventListener('variant:change', function(event) {
    const { variant } = event.detail;
    if (!variant || variant.available) return;

    if (userSelectedSize) return;

    const form = event.target;
    if (!form || form.tagName !== 'FORM') return;

    setTimeout(() => doAutoSelect(form.getAttribute('id')), 100);
  });

  function doAutoSelect(formId) {
    const variantPicker = document.querySelector(`variant-picker[form-id="${formId}"]`)
                       || document.querySelector('variant-picker');
    if (!variantPicker) return;

    const allVariantsScript = variantPicker.querySelector('script[data-all-variants]');
    if (!allVariantsScript) return;

    const allVariants = JSON.parse(allVariantsScript.textContent || '[]');
    const fieldsets = variantPicker.querySelectorAll('fieldset');
    if (fieldsets.length < 2) return;

    const colorFieldset = fieldsets[0];
    const sizeFieldset = fieldsets[1];

    const selectedColorInput = colorFieldset.querySelector('input:checked');
    const selectedSizeInput = sizeFieldset.querySelector('input:checked');
    if (!selectedColorInput || !selectedSizeInput) return;

    const currentColor = selectedColorInput.getAttribute('data-option-name');
    const currentSize = selectedSizeInput.getAttribute('data-option-name');

    const allSizeInputs = Array.from(sizeFieldset.querySelectorAll('input[data-option-name]'));
    const allSizes = allSizeInputs.map(input => input.getAttribute('data-option-name'));
    const currentSizeIndex = allSizes.indexOf(currentSize);

    const availableSizes = allVariants
      .filter(v => v.available && v.option1 === currentColor)
      .map(v => v.option2);

    if (availableSizes.length === 0) return;

    const nearestSize = findNearestSize(allSizes, currentSizeIndex, availableSizes);
    if (!nearestSize || nearestSize === currentSize) return;

    const sizeInput = sizeFieldset.querySelector(`input[data-option-name="${nearestSize}"]`);
    if (sizeInput && !sizeInput.checked) {
      sizeInput.checked = true;
      sizeInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function findNearestSize(allSizes, currentIndex, availableSizes) {
    for (let distance = 1; distance < allSizes.length; distance++) {
      const smaller = currentIndex - distance;
      if (smaller >= 0 && availableSizes.includes(allSizes[smaller])) {
        return allSizes[smaller];
      }
      const larger = currentIndex + distance;
      if (larger < allSizes.length && availableSizes.includes(allSizes[larger])) {
        return allSizes[larger];
      }
    }
    return availableSizes[0];
  }
})();
